import React, { FC, ReactElement, FocusEvent } from 'react'
import { useTranslations } from 'next-intl'
import { CodeInputField } from '../CodeInputField/CodeInputField'
import { SendCodeSingleButton } from '../SendCodeSingleButton/SendCodeSingleButton'
import { SMS_CODE_BUTTON_DEFAULT_TEXT, SMS_CODE_BUTTON_TIMEOUT_TEXT, SMS_CODE_INPUT_PLACEHOLDER } from '../../constants'
import { useTimeout } from '../../useTimeout'

type SmsCodeFieldProps = {
  name?: string
  className?: string
  error?: ReactElement | string | null
  disabled: boolean
  isCallCode: boolean
  value: string
  onChange?(data: FocusEvent<HTMLInputElement, Element>): void
  onClick(success: () => void, fail?: () => void, isCall?: boolean): void
  onFocus?(data: FocusEvent<HTMLInputElement, Element>): void
  onBlur?(data: FocusEvent<HTMLInputElement, Element>): void
}

export const SmsCodeField: FC<SmsCodeFieldProps> = ({
  className,
  error,
  disabled,
  value,
  name,
  isCallCode,
  onChange,
  onClick,
  onFocus,
  onBlur,
}) => {
  const { timeout, timeoutStart } = useTimeout()
  const t = useTranslations()

  const defaultText = t(SMS_CODE_BUTTON_DEFAULT_TEXT)
  const timeoutText = t(SMS_CODE_BUTTON_TIMEOUT_TEXT)

  const formattedTimeout = timeout < 10 ? `0${timeout}` : `${timeout}`
  const text = timeout ? `${timeoutText} 0:${formattedTimeout}` : defaultText
  const placeholder = t(SMS_CODE_INPUT_PLACEHOLDER)

  const onMouseDownHandler = () => {
    onClick(timeoutStart, undefined, false)
  }

  return (
    <>
      <CodeInputField
        name={name}
        placeholder={placeholder}
        className={className}
        disabled={disabled}
        error={error}
        value={value}
        isCallCode={isCallCode}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <SendCodeSingleButton text={text} timeout={timeout} onMouseDown={onMouseDownHandler} />
    </>
  )
}

SmsCodeField.displayName = 'SmsCodeField'
